<template>
  <v-btn v-bind="$attrs" class="app-button">
    <slot name="prepend"></slot>
    <slot />

    <slot name="append"></slot>
  </v-btn>
</template>

<style lang="scss" scoped>
// Стили для лоудера
:deep() {
  .v-progress-circular {
    color: $white !important;
  }
  .v-progress-circular__underlay {
    stroke: none !important;
  }

  .v-progress-circular--indeterminate:not(.v-progress-circular--visible) > svg,
  .v-progress-circular--indeterminate:not(.v-progress-circular--visible)
    .v-progress-circular__overlay {
    /* Чтобы анимация загрузки работала после обновления страницы  */
    animation-play-state: running !important;
  }
}
.app-button.v-btn {
  min-height: 40px;
  padding: 0 10px;
  font-weight: 700;
  color: $white;
  background-color: $primary;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(215, 68, 0, 0.4);

  &--loading {
    box-shadow: none;
    opacity: 0.5;
  }

  &--disabled[disabled] {
    color: $white !important;
    background-color: $primary !important;
    opacity: 0.5;

    :deep(.v-btn__overlay) {
      display: none;
    }
  }

  &--variant-text {
    color: $primary;
    background-color: unset !important;
    box-shadow: none !important;
  }

  &--icon {
    border-radius: 50%;
  }
}
</style>
